import './App.css';
import '@eds/vanilla/eds.min.css';
import AuthProvider from './hooks/AuthProvider';
import ThemeProvider from './hooks/ThemeProvider';
import InActiveLogoutTimer from './components/InActiveLogout/InActiveLogout';
import RouteManager from './RouteManager';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AiChatTrigger } from './components/AiChat/AiChatTrigger';

const queryClient = new QueryClient();

function App() {
  return (
    <ThemeProvider props={undefined}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouteManager />
          <InActiveLogoutTimer />
          <AiChatTrigger />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
